import React, {useEffect} from 'react';
import {withI18n} from '@shopify/react-i18n';
import {AppLayout, PostAJobCta} from '../../components';
import {
  Hero,
  ServiceCollections,
  ParentCategoriesContainer,
  HowItWorks,
} from './components';
import i18nArgs from './locales';
import {Helmet} from 'react-helmet';
import {producePageViewMonorailEvent} from '../../utilities/monorail';
import {MonorailPageIndicators} from '../../utilities/constants';

function Home() {
  useEffect(() => {
    producePageViewMonorailEvent({
      pageIndicator: MonorailPageIndicators.home,
    });
  }, []);

  return (
    <>
      <AppLayout>
        <Helmet>
          <link rel="canonical" href="https://experts.shopify.com" />
        </Helmet>
        <AppLayout.Container>
          <Hero />
        </AppLayout.Container>
        <AppLayout.Container>
          <ServiceCollections />
        </AppLayout.Container>
        <AppLayout.Container>
          <ParentCategoriesContainer />
        </AppLayout.Container>
        <AppLayout.Container>
          <HowItWorks />
        </AppLayout.Container>
      </AppLayout>
      <PostAJobCta />
    </>
  );
}

export default withI18n(i18nArgs)(Home);
